import Vue from 'vue'
import { document } from 'ssr-window'
import $ from 'jquery'
import isServer from '../../core/KServer'

const eventHub = new Vue()

export const sub = (eventName, handler) => {
  if (!isServer) {
    eventHub.$on(eventName, handler)
  }
}

export const pub = (eventName, ...args) => {
  if (!isServer) {
    eventHub.$emit(eventName, ...args)
  }
}

export const unSub = (eventNames, handler) => {
  if (!isServer) {
    eventHub.$off(eventNames, handler)
  }
}

export const CLICK_OUTSIDE = 'KAMALA_GEVENT_CLICK_OUTSIDE' // 全局点击事件
export const VIEWPORT_SCROLL = 'KAMALA_GEVENT_VIEW_PORT_SCROLL' // 全局滚动事件
export const DOCUMENT_RESIZE = 'KAMALA_GEVENT_DOCUMENT_RESIZE' // 视图尺寸变化
export const MOUSE_MOVE = 'KAMALA_GEVENT_MOUSE_MOVE' // 鼠标移动事件

// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
let supportsPassive = false
try {
  const opts = Object.defineProperty({}, 'passive', {
    get: function () {
      supportsPassive = true
    },
  })
  window.addEventListener('testPassive', null, opts)
  window.removeEventListener('testPassive', null, opts)
} catch (e) {
}

// Use our detect's results. passive applied if supported, capture will be false either way.
export const addPassiveEvent = (elem, eventName, handler) => {
  elem.addEventListener(eventName, handler, supportsPassive ? { passive: true } : false)
}

// addPassiveEvent(document, 'scroll.kamala.api', (e) => {
//   pub(VIEWPORT_SCROLL, e.target, e)
// })

if (!isServer) {
  $(document)
    .on('mousedown.kamala.api', function (e) {
      pub(CLICK_OUTSIDE, e.target, e)
    })
    .on('touchstart.kamala.api', function (e) {
      pub(CLICK_OUTSIDE, e.target, e)
    })
    .on('scroll.kamala.api', function (e) {
      pub(VIEWPORT_SCROLL, e.target, e)
    })
    .on('resize.kamala.api', function (e) {
      pub(DOCUMENT_RESIZE, e.target, e)
    })
    .on('mousemove.kamala.api', function (e) {
      pub(MOUSE_MOVE, e)
    })
}
